import { fetchJSON } from '../Fetch';
import {
  AccountAchOnlyResponse,
  AccountAchOnlyResponseRuntype,
} from '../../runtypes/AccountRuntype';

export default async function getAccountAchOnly(
  accountId: string,
): Promise<AccountAchOnlyResponse> {
  const data = await fetchJSON(`/api/account/${accountId}/achOnly`);
  if (!AccountAchOnlyResponseRuntype.guard(data)) {
    return { achOnly: false };
  }
  return data;
}
